import { FC, lazy, Suspense, useState, useEffect } from "react";
import "./Loader.css";

// Lazy load Lottie only when Loader is actually used
const LazyLottie = lazy(() => import("lottie-react"));

interface Props {
  size?: string;
}

const Loader: FC<Props> = ({ size = "200px" }) => {
  const sizeValue = parseInt(size);
  const ballSize = sizeValue * 0.15; // Tennis ball is 15% of container

  // Fallback CSS loader while Lottie loads
  const FallbackLoader = () => (
    <div 
      className="tennis-loader-container" 
      style={{ 
        height: size, 
        width: size,
        zIndex: 50000 
      }}
    >
      <div 
        className="tennis-ball"
        style={{
          width: `${ballSize}px`,
          height: `${ballSize}px`
        }}
      />
    </div>
  );

  // Dynamically import the tennis ball animation data
  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    import("./tennisBall.json").then(data => {
      setAnimationData(data.default);
    });
  }, []);

  if (!animationData) {
    return <FallbackLoader />;
  }

  return (
    <Suspense fallback={<FallbackLoader />}>
      <LazyLottie 
        animationData={animationData} 
        style={{ height: size, zIndex: 50000 }} 
      />
    </Suspense>
  );
};

export default Loader;
